import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "@/data/content";
import { FadeUp } from "./Reveal";

export const Founder = () => (
  <section data-testid="founder-section" className="border-y border-jawa-stone bg-white">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-24 lg:grid-cols-[2fr_3fr] lg:gap-16 lg:px-10 lg:py-32">
      <FadeUp>
        <div className="relative">
          <div className="absolute -left-4 -top-4 h-full w-full border border-jawa-gold/60" aria-hidden="true" />
          <img
            src={IMAGES.elizabeth}
            alt="Elizabeth, founder of JÀWÀ AFRICA"
            loading="lazy"
            decoding="async"
            className="relative w-full object-cover"
            data-testid="founder-photo"
          />
        </div>
        <p className="mt-6 font-serif text-xl italic text-jawa-espresso/80">
          "I found my way back. Then I started helping others find theirs."
        </p>
        <p className="mt-2 text-xs uppercase tracking-[0.25em] text-jawa-espresso/50">Elizabeth — Founder, JÀWÀ AFRICA</p>
      </FadeUp>

      <FadeUp delay={0.1}>
        <p className="text-xs font-semibold uppercase tracking-[0.35em] text-jawa-coral">Meet the founder</p>
        <h2 className="mt-4 font-serif text-4xl font-medium leading-tight tracking-tight text-jawa-espresso sm:text-5xl">
          The woman behind the welcome.
        </h2>
        <div className="mt-8 space-y-5 text-base leading-relaxed text-jawa-espresso/80" data-testid="founder-story">
          <p className="font-serif text-2xl text-jawa-espresso">I'm Elizabeth, founder of JÀWÀ AFRICA.</p>
          <p>
            British, with Nigerian ancestry, I found my own way back to Nigeria — and then started helping
            others find theirs. In less than two years I personally hosted more than 70 people, and JÀWÀ —
            "come back" in Yoruba — grew from that: practical guidance, trusted connections and a welcome
            that feels like family.
          </p>
        </div>
        <Link
          to="/about"
          data-testid="founder-read-more"
          className="mt-8 inline-flex items-center gap-1.5 border border-jawa-espresso/25 px-6 py-3 text-xs font-semibold uppercase tracking-[0.25em] text-jawa-espresso transition-colors hover:border-jawa-coral hover:text-jawa-coral"
        >
          Read my full story <ArrowUpRight className="h-4 w-4" />
        </Link>
      </FadeUp>
    </div>
  </section>
);
